export enum SettingsParamsKeys {
  descriptionLimitRows = 'descriptionLimitRows',
  deliveryDate = 'deliveryDate',
  quantity = 'quantity',
  productTitleAlignment = 'productTitleAlignment',
  descriptionAlignment = 'descriptionAlignment',
  buyNowButtonText = 'buyNowButtonText',
  showBuyNowButton = 'showBuyNowButton',
  showAddToCartButton = 'showAddToCartButton',
  addToCartButtonText = 'addToCartButtonText',
  amountLabel = 'amountLabel',
  recipientEmailLabel = 'recipientEmailLabel',
  enterCustomAmountLabel = 'enterCustomAmountLabel',
  otherAmountVariantLabel = 'otherAmountVariantLabel',
  deliveryDateLabel = 'deliveryDateLabel',
  deliveryTimeLabel = 'deliveryTimeLabel',
  deliveryDateDefaultText = 'deliveryDateDefaultText',
  recipientNameLabel = 'recipientNameLabel',
  giftMessageLabel = 'giftMessageLabel',
  quantityLabel = 'quantityLabel',
  descriptionReadMoreButton = 'descriptionReadMoreButton',
  descriptionReadLessButton = 'descriptionReadLessButton',
  amountErrorMessage = 'amountErrorMessage',
  recipientEmailErrorMessage = 'recipientEmailErrorMessage',
  srDeliveryDateChooseDateButton = 'srDeliveryDateChooseDateButton',
  srQuantityRemoveQuantity = 'srQuantityRemoveQuantity',
  srQuantityTotalQuantity = 'srQuantityTotalQuantity',
  increaseQuantityAriaLabel = 'increaseQuantityAriaLabel',
  decreaseQuantityAriaLabel = 'decreaseQuantityAriaLabel',
  srQuantityAddQuantity = 'srQuantityAddQuantity',
  quantityErrorMessage = 'quantityErrorMessage',
  giftCardForLabel = 'giftCardForLabel',
  someoneElseButton = 'someoneElseButton',
  myselfButton = 'myselfButton',
  giftCardFor = 'giftCardFor',
  addToCartPostAction = 'addToCartPostAction',
  displayTitle = 'displayTitle',
  displayDescription = 'displayDescription',
  displayAmountOptions = 'displayAmountOptions',
  displayQuantitySelector = 'displayQuantitySelector',
  displayImage = 'displayImage',
}

export enum StylesParamsKeys {
  productTitleColor = 'productTitleColor',
  productTitleFont = 'productTitleFont',
  productPriceColor = 'productPriceColor',
  productPriceFont = 'productPriceFont',
  productDescriptionColor = 'productDescriptionColor',
  productDescriptionFont = 'productDescriptionFont',
  backgroundColor = 'backgroundColor',
  imageBorderColor = 'imageBorderColor',
  imageBorderWidth = 'imageBorderWidth',
  imageCornerRadius = 'imageCornerRadius',
  imageRatio = 'imageRatio',
  inputFieldBackgroundColor = 'inputFieldBackgroundColor',
  inputFieldBorderColor = 'inputFieldBorderColor',
  inputFieldBorderWidth = 'inputFieldBorderWidth',
  inputFieldFont = 'inputFieldFont',
  inputFieldColor = 'inputFieldColor',
  inputFieldTitlesColor = 'inputFieldTitlesColor',
  inputFieldTitlesFont = 'inputFieldTitlesFont',
  CalendarDayColor = 'CalendarDayColor',
  CalendarBackgroundColor = 'CalendarBackgroundColor',
  CalendarSelectedDayBgColor = 'CalendarSelectedDayBgColor',
  CalendarSelectedDayTextColor = 'CalendarSelectedDayTextColor',
  selectionButtonsCornerRadius = 'selectionButtonsCornerRadius',
  inputFieldsCornerRadius = 'inputFieldsCornerRadius',
  ProductVariantsFillColorOpacity = 'ProductVariantsFillColorOpacity',
  ProductVariantsBorderColor = 'ProductVariantsBorderColor',
  ProductVariantsBorderWidth = 'ProductVariantsBorderWidth',
  ProductVariantsSelectedBoxColor = 'ProductVariantsSelectedBoxColor',
  ProductVariantsTextColor = 'ProductVariantsTextColor',
  ProductVariantsTextFont = 'ProductVariantsTextFont',
  AmountSelectorOptionFillColorOpacity = 'AmountSelectorOptionFillColorOpacity',
  AmountSelectorOptionSelectedBoxColor = 'AmountSelectorOptionSelectedBoxColor',
  AmountSelectorOptionBorderColor = 'AmountSelectorOptionBorderColor',
  AmountSelectorOptionBorderWidth = 'AmountSelectorOptionBorderWidth',
  AmountSelectorOptionTextColor = 'AmountSelectorOptionTextColor',
  AmountSelectorOptionTextFont = 'AmountSelectorOptionTextFont',
  AmountSelectorOptionCornerRadius = 'AmountSelectorOptionCornerRadius',
  GiftCardRecipientFillColorOpacity = 'GiftCardRecipientFillColorOpacity',
  GiftCardRecipientTextColor = 'GiftCardRecipientTextColor',
  GiftCardRecipientTextFont = 'GiftCardRecipientTextFont',
  GiftCardRecipientSelectedBoxColor = 'GiftCardRecipientSelectedBoxColor',
  GiftCardRecipientBorderColor = 'GiftCardRecipientBorderColor',
  GiftCardRecipientBorderWidth = 'GiftCardRecipientBorderWidth',
  GiftCardRecipientCornerRadius = 'GiftCardRecipientCornerRadius',
  BuyNowButtonTextFont = 'BuyNowButtonTextFont',
  BuyNowButtonTextColor = 'BuyNowButtonTextColor',
  BuyNowButtonCornerRadius = 'BuyNowButtonCornerRadius',
  BuyNowButtonBorderColor = 'BuyNowButtonBorderColor',
  BuyNowButtonBorderWidth = 'BuyNowButtonBorderWidth',
  BuyNowButtonFillColorOpacity = 'BuyNowButtonFillColorOpacity',
  AddToCartButtonTextFont = 'AddToCartButtonTextFont',
  AddToCartButtonTextColor = 'AddToCartButtonTextColor',
  AddToCartButtonCornerRadius = 'AddToCartButtonCornerRadius',
  AddToCartButtonBorderColor = 'AddToCartButtonBorderColor',
  AddToCartButtonBorderWidth = 'AddToCartButtonBorderWidth',
  AddToCartButtonFillColorOpacity = 'AddToCartButtonFillColorOpacity',
  shouldShowTitle = 'shouldShowTitle',
  shouldShowDescription = 'shouldShowDescription',
  shouldShowAmountOptions = 'shouldShowAmountOptions',
  shouldShowQuantitySelector = 'shouldShowQuantitySelector',
  shouldShowImage = 'shouldShowImage',
  shouldShowDeliveryDate = 'shouldShowDeliveryDate',
  shouldShowDeliveryDateAndTime = 'shouldShowDeliveryDateAndTime',
  shouldShowAddToCartButton = 'shouldShowAddToCartButton',
  shouldShowBuyNowButton = 'shouldShowBuyNowButton',
}
